import { Broadcast } from "../classes/Broadcast"
import { Map } from "../functions/Map"
import type { AsyncSequence } from "../types/AsyncSequence"
import { ProcessIterable } from "./ProcessIterable"
import { SafePromise } from "./SafePromise"

export function MapAsyncConcurrent<T, N>(
    func: (item: T, index: number) => N | Promise<N>,
  ...arrays: AsyncSequence<T>[]
): AsyncGenerator<N> {
  const { push, stop, subscribe } = Broadcast<N>()
  const subscription = subscribe()

  let seen = 0
  let done = 0
  let completed = false

  const final_stop = () => (completed && done === seen ? stop(undefined) : null)

  const promises = Map(
    iterable =>
      ProcessIterable(
        iterable,
        s =>
          void SafePromise(func(s, seen++) as Promise<N>).then(({ error, value }) => {
            done++
            if (error) {
              stop(error)
            } else {
              push(value)
              final_stop()
            }
          }),
        (error?: Error) => (error ? stop(error) : null)
      ),
    arrays
  )

  void Promise.all(promises).then(() => {
    completed = true
    final_stop()
  })

  return subscription
}
